import { useQuery } from "@tanstack/react-query";

// Life/disability coverage setups by plan id. Without one the calculator
// prices the plan $0 ("Coverage not configured"). Pass only life/disability
// plan ids; other types have no config row.
export function useLifeDisabilityConfigs(ldPlanIds: number[]): {
  ldConfigByPlanId: Record<number, any>;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery<Record<number, any>>({
    queryKey: ["/api/plans/life-disability-configs", ldPlanIds],
    queryFn: async () => {
      const configMap: Record<number, any> = {};
      await Promise.all(
        ldPlanIds.map(async (planId: number) => {
          try {
            const res = await fetch(`/api/plans/${planId}/life-disability-config`);
            if (res.ok) {
              const data = await res.json();
              if (data) configMap[planId] = data;
            }
          } catch {}
        })
      );
      return configMap;
    },
    enabled: ldPlanIds.length > 0,
    staleTime: Infinity,
  });
  return { ldConfigByPlanId: data ?? {}, isLoading: ldPlanIds.length > 0 && isLoading };
}
